
  <img
    [ngClass]="class"
    ngSrc="{{ src }}"
    priority
    alt="{{ alt }}"
    width="{{ width }}"
    height="{{ height }}"
    decoding="async"
    (load)="imageLoaded()" />

